module.exports = __webpack_public_path__ + "16f70f84ba92698d15d6dd74717a6538.png";